var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRoute } from 'ziggy-js';
import JetActionMessage from '@/Jetstream/ActionMessage';
import JetButton from '@/Jetstream/Button';
import JetFormSection from '@/Jetstream/FormSection';
import JetInput from '@/Jetstream/Input';
import JetInputError from '@/Jetstream/InputError';
import JetLabel from '@/Jetstream/Label';
import JetSecondaryButton from '@/Jetstream/SecondaryButton';
import { router } from '@inertiajs/react';
import { useForm } from '@inertiajs/react';
import classNames from 'classnames';
import { useRef, useState } from 'react';
import { Ziggy } from "@/ziggy";
export default function UpdateTeamNameForm(_a) {
    var team = _a.team, permissions = _a.permissions;
    var route = useRoute(Ziggy);
    var form = useForm({
        _method: 'PUT',
        name: team.name,
        photo: null,
    });
    var photoRef = useRef(null);
    var _b = useState(null), photoPreview = _b[0], setPhotoPreview = _b[1];
    function selectNewPhoto() {
        var _a;
        (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }
    function updateTeamName() {
        console.log('updateTeamName', form.data);
        form.post(route('teams.update', [team]), {
            errorBag: 'updateTeamName',
            preserveScroll: true,
            onSuccess: function () { return clearPhotoFileInput(); },
        });
    }
    function updatePhotoPreview() {
        var _a, _b, _c, _d;
        var photo = (_b = (_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.files) === null || _b === void 0 ? void 0 : _b[0];
        if (!photo)
            return;
        var reader = new FileReader();
        reader.onload = function (e) {
            var _a;
            setPhotoPreview((_a = e.target) === null || _a === void 0 ? void 0 : _a.result);
        };
        reader.readAsDataURL(photo);
        form.setData('photo', ((_d = (_c = photoRef.current) === null || _c === void 0 ? void 0 : _c.files) === null || _d === void 0 ? void 0 : _d[0]) || null);
    }
    function removePhoto() {
        router.post(route('team.removeLogo', { team: team }), {}, {
            preserveScroll: true,
            onSuccess: function () {
                setPhotoPreview(null);
                clearPhotoFileInput();
            },
        });
    }
    function clearPhotoFileInput() {
        var _a;
        if ((_a = photoRef.current) === null || _a === void 0 ? void 0 : _a.value) {
            photoRef.current.value = '';
        }
    }
    return (_jsxs(JetFormSection, __assign({ onSubmit: updateTeamName, title: 'Team name', description: "The team's name and owner information.", renderActions: team.permissions.update
            ? function () { return (_jsxs(_Fragment, { children: [_jsx(JetActionMessage, __assign({ on: form.recentlySuccessful, className: "mr-3" }, { children: "Saved." })), _jsx(JetButton, __assign({ id: "save-team-name", className: classNames({ 'opacity-25': form.processing }), disabled: form.processing }, { children: "Save" }))] })); }
            : undefined }, { children: [_jsxs("div", __assign({ className: "col-span-6" }, { children: [_jsx(JetLabel, { value: "Team owner" }), _jsxs("div", __assign({ className: "flex items-center mt-2" }, { children: [_jsx("img", { className: "w-12 h-12 rounded-full object-cover", src: team.owner.profile_photo_url, alt: team.owner.name }), _jsxs("div", __assign({ className: "ml-4 leading-tight" }, { children: [_jsx("div", { children: team.owner.name }), _jsx("div", __assign({ className: "text-gray-700 text-sm" }, { children: team.owner.email }))] }))] }))] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx(JetLabel, { htmlFor: "name", value: "Team name" }), _jsx(JetInput, { id: "name", type: "text", className: "mt-1 block w-full ".concat(!team.permissions.update ? "text-gray-500 cursor-disabled" : ""), value: form.data.name, onChange: function (e) { return form.setData('name', e.currentTarget.value); }, disabled: !team.permissions.update }), _jsx(JetInputError, { message: form.errors.name, className: "mt-2" })] })), _jsxs("div", __assign({ className: "col-span-6 sm:col-span-4" }, { children: [_jsx("input", { type: "file", className: "hidden", ref: photoRef, onChange: updatePhotoPreview, accept: "image/*" }), _jsx(JetLabel, { htmlFor: "logo", value: "Logo" }), photoPreview ? (
                    // <!-- New Profile Photo Preview -->
                    _jsx("div", __assign({ className: "mt-2" }, { children: _jsx("span", { className: "block w-20 h-20", style: {
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                backgroundImage: "url('".concat(photoPreview, "')"),
                            } }) }))) : (
                    // <!-- Current Profile Photo -->
                    _jsx("div", __assign({ className: "mt-2" }, { children: _jsx("span", { className: "block w-20 h-20 border", style: {
                                backgroundSize: 'contain',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                backgroundImage: "url('".concat(team.profile_photo_url, "')"),
                            } }) }))), team.permissions.update && _jsxs(_Fragment, { children: [_jsx(JetSecondaryButton, __assign({ className: "mt-2 mr-2", type: "button", onClick: selectNewPhoto }, { children: "Upload a logo" })), team.profile_photo_url ? (_jsx(JetSecondaryButton, __assign({ type: "button", className: "mt-2", onClick: removePhoto }, { children: "Remove logo" }))) : null, _jsx(JetInputError, { message: form.errors.photo, className: "mt-2" })] })] }))] })));
}
